import { Component, OnInit } from '@angular/core';
import {ProductTileConfig} from '../../models/product-tile-config';
import {ProductTileKey} from '../../enums/product-tile-key.enum';
import {InternalConfigService} from '../../services/internal-config.service';

@Component({
  selector: 'app-other-products',
  templateUrl: './other-products.component.html',
  styleUrls: []
})
export class OtherProductsComponent implements OnInit {

  products: ProductTileConfig[] = [
    {
      key: ProductTileKey.TRAVEL,
      title: 'OTHER_PRODUCTS.TRAVEL.TITLE',
      image: './assets/images/products/travel.svg',
      label: 'OTHER_PRODUCTS.TRAVEL.LABEL',
      action: {
        label: 'OTHER_PRODUCTS.BUY_POLICY',
        url: this.configurationService.getProductUrl(ProductTileKey.TRAVEL)
      }
    },
    {
      key: ProductTileKey.CDW,
      title: 'OTHER_PRODUCTS.CDW.TITLE',
      image: './assets/images/products/cdw.svg',
      label: 'OTHER_PRODUCTS.CDW.LABEL',
      action: {
        label: 'OTHER_PRODUCTS.BUY_POLICY',
        url: this.configurationService.getProductUrl(ProductTileKey.CDW)
      }
    },
    {
      key: ProductTileKey.HOME,
      title: 'OTHER_PRODUCTS.HOME.TITLE',
      image: './assets/images/products/home.svg',
      label: 'OTHER_PRODUCTS.HOME.LABEL',
      action: {
        label: 'OTHER_PRODUCTS.BUY_POLICY',
        url: this.configurationService.getProductUrl(ProductTileKey.HOME)
      }
    }
  ];

  constructor(private configurationService: InternalConfigService) { }

  ngOnInit(): void {
  }

}
